// extracted by mini-css-extract-plugin
module.exports = {"container":"regionBasePermission_container__1VudQ"};